import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "../icons/Icon.js";
import { Field } from "./Field.js";
export function SearchField(props) {
    return _jsx(Field, { type: "search", iconStart: _jsx(Icon, { name: "search", size: 16 }), ...props });
}
export function DateField(props) {
    return _jsx(Field, { type: "date", iconStart: _jsx(Icon, { name: "calendar", size: 16 }), ...props });
}
//# sourceMappingURL=SearchField.js.map